import { checkPermission } from '../lib/permissions'

export default {
  install (Vue) {
    Vue.prototype.$checkPermission = checkPermission
  }
}
